module.exports = __webpack_public_path__ + "img/maison17.66b8aa27.jpg";